// Recovered compiled webpack factory 86897. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  var r = Symbol.for("react.transitional.element");
  function n(e, t, n) {
    var a = null;
    if ((void 0 !== n && (a = "" + n), void 0 !== t.key && (a = "" + t.key), "key" in t))
      for (var o in ((n = {}), t)) "key" !== o && (n[o] = t[o]);
    else n = t;
    return { $$typeof: r, type: e, key: a, ref: void 0 !== (t = n.ref) ? t : null, props: n };
  }
  ((t.Fragment = Symbol.for("react.fragment")), (t.jsx = n), (t.jsxs = n));
}
